import { LoadingScreen } from "@/components/LoadingScreen";

// Suspense fallback shown while a lazily-loaded route chunk is fetched.
export const PageLoader = () => <LoadingScreen />;
